<template>
    <div class="input-yzm">
        <el-input placeholder="请输入验证码" v-model="verifyCode" :placeHolder="verifyCodeHint"></el-input>
        <input type="password" style="position: fixed;bottom: -9999px;">
        <input type="button" v-model="count" class="cs-btn btn-yzm" @click="onGetVerifyCodeClick" ref="code"/>
    </div>
</template>

<script>
    import Vue from 'vue'


    export default {
        name: "TopTipDialog",
        data() {
            return {
                count: '获取验证码',
                timer: null,
                wait: 0,
                verifyCode: '',
            }
        },
        props: {
            onGetVerifyCodeClick: {
                type: Function
            },
            // verifyCode: {
            //     type: String
            // },
            verifyCodeHint: {
                type: String
            },

        },
        mounted() {
            this.count = this.$store.state.i18n.getCode[this.$store.state.CN_EN]
        },
        methods: {
            // getVerifyCode() {
            //     console.log('getVerifyCode in comp')
            //     // this.onGetVerifyCodeClick(result=>{
            //     //     if(result){
            //     //        this.countDown()
            //     //     }
            //     // })
            //     this.onGetVerifyCodeClick()
            // },
            countDown() {
                this.$refs.code.setAttribute("disabled", true)
                const TIME_COUNT = 60
                if (!this.timer) {
                    this.wait = TIME_COUNT
                    this.timer = setInterval(() => {
                        if (this.wait > 0 && this.wait <= TIME_COUNT) {
                            this.$refs.code.setAttribute("disabled", true)
                            this.count = this.wait + "s"
                            this.wait--
                            // console.log(this.$refs.yzm)
                        } else {
                            this.$refs.code.removeAttribute("disabled")
                            clearInterval(this.timer)
                            this.count = this.$store.state.i18n.getCode[this.$store.state.CN_EN]
                            this.timer = undefined
                        }
                    }, 1000)
                } else {

                }
            },
            getVerifyCode() {
                return this.verifyCode
            },
            restore() {
                this.verifyCode = ''
            },
            resetWait() {
                this.wait = 0
            }
        }
    }
</script>

<style scoped>
    .input-yzm {
        display: inline-block;
        width: 100%;
        position: relative;
    }

    .cs-btn {
        display: inline-block;
        border-radius: 4px;
        padding: 6px 15px;
        margin-right: 8px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        border: none;
        outline: none;
    }

    .btn-yzm {
        position: absolute;
        right: 0px;
        top: 5px;
        width: 105px;
        background: transparent;
        color: #269bff;
    }

    input[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
